import React from 'react'
import TopBanner from '../../../components/topBanner/topBanner'
import imgBaner from "../../../images/banner/banner---gioi-thieu.png"
import { useParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { removeVietnameseTones } from '../../../utils/translationHelpers';
import { normalizeLang } from '../../../utils/localeDataLoader';
import { useLeadershipOverviewQuery } from 'hooks';
import { getLeaderCategoryIds, normalizeLeaderPositions } from '../../../utils/leaderHelpers';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

export default function MemberContent() {
    const { slug, categorySlug } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [dataLanguage, setDataLanguage] = useState('');
    const [dataCategoryId, setDataCategoryId] = useState(null);
    const { t, i18n } = useTranslation();
    const currentLang = normalizeLang(i18n.language);
    const { data: leadershipData = { leaders: [], categories: [] } } = useLeadershipOverviewQuery(currentLang);
    const { leaders, categories } = leadershipData;

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (!categories.length || !leaders.length || !currentLang) return;

        const currentCategory = categories.find(c => c.slug === categorySlug);
        const catId = currentCategory ? currentCategory.id : null;

        for (var item of leaders) {
            if (item.slug === slug && getLeaderCategoryIds(item).includes(Number(catId))) {
                setData(item);
                setDataLanguage(currentLang);
                setDataCategoryId(catId);
                break;
            }
        }
    }, [leaders, categories, slug, categorySlug, currentLang]);

    // Handle path change when language changes
    useEffect(() => {
        if (!categories.length || !leaders.length || !data) return;
        
        const lang = currentLang;
        if (dataLanguage && dataLanguage !== lang) {
            const targetLeader = leaders.find(l => l.id === data.id);
            const targetCategory = categories.find(c => Number(c.id) === Number(dataCategoryId))
                || categories.find(c => getLeaderCategoryIds(targetLeader).includes(Number(c.id)));

            if (targetLeader && targetCategory) {
                const basePath = lang === 'vi' ? 'gioi-thieu/ban-lanh-dao' : 'about-us/leadership';
                navigate(`/${basePath}/${targetCategory.slug}/${targetLeader.slug}`, { replace: true });
            }
        }
    }, [currentLang, leaders, categories, data, dataLanguage, dataCategoryId, navigate]);

    const informationItems = data?.informationItems
        ?.filter((item) => item?.isActive !== false && (item?.title || item?.description))
        .sort((first, second) => (Number(first.sortOrder) || 0) - (Number(second.sortOrder) || 0)) || [];
    const displayName = data ? (normalizeLang(i18n.language) !== 'vi' ? removeVietnameseTones(data.name) : data.name) : "";
    const positions = normalizeLeaderPositions(data?.positions);
    const leaderImage = data?.image || data?.img || data?.imageUrl;
    const labels = currentLang === 'vi'
        ? {
            eyebrow: 'Hồ sơ lãnh đạo',
            education: 'Học vấn',
            empty: 'Thông tin lãnh đạo đang được cập nhật.',
        }
        : {
            eyebrow: 'Leadership profile',
            education: 'Education',
            empty: 'Leadership information is being updated.',
        };
    return (
        <div className='MemberContent'>
            <TopBanner
                imgBanner={imgBaner}
                pageName={t('pages.leadership')}
                titleCenter={t('pages.leadership')}
                text={displayName}
            />
            <div className='layout_container'>
                {data && (
                    <section className="leader-profile-hero">
                        <div className="leader-profile-hero__visual">
                            <span className="leader-profile-hero__orbit leader-profile-hero__orbit--outer" />
                            <span className="leader-profile-hero__orbit leader-profile-hero__orbit--inner" />
                            <div className="leader-profile-hero__portrait">
                                {leaderImage ? (
                                    <img src={leaderImage} alt={displayName} />
                                ) : (
                                    <span>{displayName?.trim()?.charAt(0)}</span>
                                )}
                                <div className="leader-profile-hero__identity">
                                    <h1>{displayName}</h1>
                                    {positions.length > 0 && (
                                        <div className="leader-profile-hero__roles">
                                            {positions.map((position, index) => <span key={index}>{position}</span>)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="leader-profile-hero__content">
                            <span className="leader-profile-hero__eyebrow">{labels.eyebrow}</span>

                            {data.education && (
                                <div className="leader-profile-hero__education">
                                    <span>{labels.education}</span>
                                    <strong>{data.education}</strong>
                                </div>
                            )}

                            <Swiper
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                modules={[Pagination]}
                                className="leader-profile-slider"
                            >
                                {informationItems.length > 0 ? informationItems.map((item, index) => (
                                    <SwiperSlide key={item.id || index}>
                                        <article className="leader-profile-slide">
                                            <span className="leader-profile-slide__index">{String(index + 1).padStart(2, '0')}</span>
                                            {item.title && <h2>{item.title}</h2>}
                                            {item.description && <div className="quill-content" dangerouslySetInnerHTML={{ __html: item.description }} />}
                                        </article>
                                    </SwiperSlide>
                                )) : (
                                    <SwiperSlide>
                                        <p className="leader-profile-slide__empty">{labels.empty}</p>
                                    </SwiperSlide>
                                )}
                            </Swiper>
                        </div>
                    </section>
                )}
            </div>
        </div>
    )
}
